import { apiClient } from "../lib/apiClient";
import { workstationPreferenceService } from "./workstationPreference.service";

export interface PrintStickerRequest {
  itemId: string;
  itemType: "slide" | "block";
  caseId: string;
  workstationId: string;
  clientRequestId: string;
  isReprint?: boolean;
  reprintReason?: string;
  reprintReasonText?: string;
}

export interface BatchPrintLabelsRequest {
  caseId: string;
}

export interface BatchPrintSummary {
  stickersDispatched: number;
  printMateDispatched: number;
  slideMateDeferred: number;
  errors: any[];
}

export const stickerService = {
  printSticker: async (data: PrintStickerRequest) => {
    const response = await apiClient.post("/sticker/print", data);
    return response.data;
  },

  reprintSticker: async (data: PrintStickerRequest) => {
    const response = await apiClient.post("/sticker/reprint", data);
    return response.data;
  },

  /**
   * Dispatch already-built sticker label items to the bridge for slides that
   * are not yet persisted (printed during accessioning). The backend relays the
   * command to the workstation bridge over its WebSocket. `delivered` is false
   * when no live bridge received the command.
   */
  dispatchStickerLabels: async (data: {
    workstationId: string;
    deviceId: string;
    items: unknown[];
  }): Promise<{ delivered: boolean; commandId: string }> => {
    const response = await apiClient.post("/sticker/dispatch-labels", data);
    return response.data;
  },

  batchPrintLabels: async (caseId: string) => {
    const workstationId =
      workstationPreferenceService.getSelectedWorkstationId();
    const response = await apiClient.post<BatchPrintSummary>(
      `/cases/${caseId}/print-labels`,
      { workstationId }
    );
    return response.data;
  },

  getAudit: async (params: any) => {
    const response = await apiClient.get("/sticker/audit", { params });
    return response.data;
  },

  toggleReceivedCompleted: async (
    itemType: string,
    itemId: string,
    data: any
  ) => {
    const response = await apiClient.patch(
      `/sticker/items/${itemType}/${itemId}/received-completed`,
      data
    );
    return response.data;
  },

  getPrinterStatus: async (workstationId: string) => {
    const response = await apiClient.get(
      `/bridge/workstations/${workstationId}/sticker-printer-status`
    );
    return response.data;
  },

  testPrint: async (workstationId: string, deviceId: string) => {
    const response = await apiClient.post("/sticker/test-print", {
      workstationId,
      deviceId,
    });
    return response.data;
  },
};
